import './MultiMetricCard.scss'

import { Card, Explination } from '@enkla-gui'

import React from 'react'

const SkeletonLoader = ({ count = 3 }) => (
	<div className="metric-grid">
		{Array.from({length: count}, (_, i) => (
			<div className="metric-item" key={i}>
				<div className="metric-icon skeleton"></div>
				<div className="metric-info">
					<div className="skeleton-text" style={{width: '60px', height: '20px'}}></div>
					<div className="skeleton-text" style={{width: '50px', height: '14px', marginTop: '4px'}}></div>
				</div>
			</div>
		))}
	</div>
)

// Map color classes to actual colors for icon backgrounds
const getIconColors = (colorClass) => {
	const colors = {
		'text-primary': { bg: '#e3f2fd', color: '#1976d2' },
		'text-success': { bg: '#e8f5e9', color: '#2e7d32' },
		'text-warning': { bg: '#fff3e0', color: '#f57c00' },
		'text-danger': { bg: '#ffebee', color: '#c62828' },
		'text-info': { bg: '#e0f7fa', color: '#0097a7' },
	}
	return colors[colorClass] || colors['text-primary']
}

export default function MultiMetricCard({
	title,
	icon,
	metrics = [],
	loading = false,
	tippy = null,
	className = "mb-3"
}) {
	return (
		<Card title={title} icon={icon} class={className} collapsed={null}>
			{loading ? (
				<SkeletonLoader count={metrics.length || 3} />
			) : (
				<div className="metric-grid">
					{metrics.map((metric, index) => {
						const iconColors = getIconColors(metric.color)
						return (
							<div className="metric-item" key={index}>
								<div
									className="metric-icon"
									style={{ backgroundColor: iconColors.bg, color: iconColors.color }}
								>
									<i className={`fas ${metric.icon}`}></i>
								</div>
								<div className="metric-info">
									<div className="metric-value">{metric.value}</div>
									<div className="metric-label">
										{metric.label}
										{metric.tooltip && (
											<Explination tip={metric.tooltip} />
										)}
									</div>
								</div>
							</div>
						)
					})}
				</div>
			)}
		</Card>
	)
}
